"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// import  Recorder from "src/index";
var download_1 = require("../download/download");
var player_1 = require("../player/player");
var transform_1 = require("../transform/transform");
var createAutoCancellation_1 = require("./createAutoCancellation");
var INPUT_FILE_PATH = "input.pcm";
var OUTER_FILE_PATH = "outer.pcm";
var autoCancellation = function (recorder) {
    var rattle = {
        instance: null,
        isLoaded: false,
        load: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.instance = createAutoCancellation_1.createAutoCancellation();
                            // 加载autocancellation
                            return [4 /*yield*/, this.instance.load()];
                        case 1:
                            // 加载autocancellation
                            _a.sent();
                            this.isLoaded = true;
                            return [2 /*return*/];
                    }
                });
            });
        },
        getPCM: function (withCache) {
            if (withCache === void 0) { withCache = false; }
            return __awaiter(this, void 0, void 0, function () {
                var pcmData, instance, inFilename, outFilename, outPcmData;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            pcmData = recorder.getPCM();
                            if (!!this.isLoaded) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.load()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            instance = this.instance;
                            inFilename = INPUT_FILE_PATH;
                            outFilename = OUTER_FILE_PATH;
                            instance.FS("writeFile", inFilename, new Uint8Array(pcmData.buffer));
                            //执行转换
                            return [4 /*yield*/, instance.run(inFilename, outFilename)];
                        case 3:
                            //执行转换
                            _a.sent();
                            outPcmData = instance.FS("readFile", outFilename);
                            return [2 /*return*/, new DataView(outPcmData.buffer)];
                    }
                });
            });
        },
        getWavUrl: function () {
            return __awaiter(this, void 0, void 0, function () {
                var wabBlob, href;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getWAVBlob()];
                        case 1:
                            wabBlob = _a.sent();
                            href = window.URL.createObjectURL(wabBlob);
                            return [2 /*return*/, href];
                    }
                });
            });
        },
        /**
         * 获取WAV编码的二进制数据(dataview)
         *
         * @returns {dataview}  WAV编码的二进制数据
         * @memberof Recorder
         */
        getWAV: function () {
            return __awaiter(this, void 0, void 0, function () {
                var pcmTemp, inputSampleRate, outputSampleRate, config, oututSampleBits, littleEdian;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getPCM()];
                        case 1:
                            pcmTemp = _a.sent();
                            inputSampleRate = recorder.inputSampleRate, outputSampleRate = recorder.outputSampleRate, config = recorder.config, oututSampleBits = recorder.oututSampleBits, littleEdian = recorder.littleEdian;
                            // PCM增加44字节的头就是WAV格式了
                            return [2 /*return*/, transform_1.encodeWAV(pcmTemp, inputSampleRate, outputSampleRate, config.numChannels, oututSampleBits, littleEdian)];
                    }
                });
            });
        },
        /**
         * 获取WAV音频的blob数据
         *
         * @returns { blob }    wav格式blob数据
         * @memberof Recorder
         */
        getWAVBlob: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = Blob.bind;
                            return [4 /*yield*/, this.getWAV()];
                        case 1: return [2 /*return*/, new (_a.apply(Blob, [void 0, [_b.sent()], { type: "audio/wav" }]))()];
                    }
                });
            });
        },
        /**
         * 下载录音pcm数据
         *
         * @param {string} [name='recorder']    重命名的名字
         * @memberof Recorder
         */
        downloadPCM: function (name) {
            if (name === void 0) { name = "recorder"; }
            var instance = this.instance;
            var outFilename = OUTER_FILE_PATH;
            //读取转换后的结果
            var pcmBlob = instance.FS("readFile", outFilename);
            // let pcmBlob = this.getPCMBlob();
            download_1.downloadPCM(pcmBlob, name);
        },
        play: function () {
            return __awaiter(this, void 0, void 0, function () {
                var dataV;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            recorder.stop();
                            // 关闭前一次音频播放
                            recorder.isplaying = true;
                            recorder.onpclay && recorder.onplay();
                            player_1.default.addPlayEnd(recorder.onplayend); // 注册播放完成后的回调事件
                            return [4 /*yield*/, this.getWAV()];
                        case 1:
                            dataV = _a.sent();
                            this.cache = dataV;
                            if (dataV.byteLength > 44) {
                                player_1.default.play(dataV.buffer); // 播放
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        playWithCache: function (forceLoad) {
            if (forceLoad === void 0) { forceLoad = false; }
            return __awaiter(this, void 0, void 0, function () {
                var dataV;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.cache && !forceLoad)) return [3 /*break*/, 1];
                            recorder.stop();
                            // 关闭前一次音频播放
                            recorder.isplaying = true;
                            recorder.onplay && recorder.onplay();
                            player_1.default.addPlayEnd(recorder.onplayend); //
                            dataV = this.cache;
                            if (dataV.byteLength > 44) {
                                player_1.default.play(dataV.buffer); // 播放
                            }
                            return [3 /*break*/, 3];
                        case 1: return [4 /*yield*/, this.play()];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        getPlayAnalyseData: function () {
            // Player
        },
        destory: function () {
            // try {
            //     const { instance } = this;
            //     // instance.FS("unlink", INPUT_FILE_PATH);
            //     // instance.FS("unlink", OUTER_FILE_PATH);
            // } catch (error) {
            //     console.log(
            //         "🚀 -> file: index.ts:158 -> destory -> error",
            //         error
            //     );
            // }
            this.cache = null;
        },
    };
    Object.assign(recorder, { rattle: rattle });
    // const play = recorder.play.bind(recorder);
    // const stop = recorder.stop.bind(recorder);
    // recorder.play = () => {
    //     if (recorder.isRattle) {
    //         rattle.play();
    //     } else {
    //         play();
    //     }
    // };
    // recorder.stop = () => {
    //     if (recorder.isRattle) {
    //         rattle.stop();
    //     } else {
    //         stop();
    //     }
    // };
    return rattle;
};
exports.default = [autoCancellation];
//# sourceMappingURL=index.js.map